import * as React from "react";
import PolicyPage from "../../components/PolicyPage";
import { useLang } from "../../lib/lang";
import content from "./content";

const TermsOfUse = () => {
  const lang = useLang();
  return <PolicyPage sections={content[lang]} />;
};

export default TermsOfUse;
